export default {
  GET_CURRENT_USER: (state) => {
    return state.currentUser;
  },
  GET_USERS: (state) => {
    return state.users;
  },
  GET_USERS_PENDING_APPROVAL: (state) => {
    return state.usersPendingApproval;
  },
  GET_USERS_LOGGED_IN_TODAY: (state) => {
    return state.usersLoggedInToday;
  },
  GET_USERS_REJECTED: (state) => {
    return state.usersRejected;
  },
  GET_USERS_WITHOUT_SEPIA_INFO: (state) => {
    return state.usersWithoutSepiaInfo;
  },
};
